module.exports = __webpack_public_path__ + "static/img/ndvi2.b7928d95.jpg";